module.exports = __webpack_public_path__ + "static/kentico-logo-f887ced7bb869f643e6b29197417ffdd.png";